import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClose", "setInitialFocusRef"];
import React, { useContext } from 'react';
import MenuGroup from '@atlaskit/menu/menu-group';
import { FocusManagerContext } from '../components/focus-manager';
import isCheckboxItem from '../utils/is-checkbox-item';
import isRadioItem from '../utils/is-radio-item';
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */

var MenuWrapper = function MenuWrapper(_ref) {
  var onClose = _ref.onClose,
      setInitialFocusRef = _ref.setInitialFocusRef,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(FocusManagerContext),
      menuItemRefs = _useContext.menuItemRefs;

  var closeOnMenuItemClick = function closeOnMenuItemClick(e) {
    var isTargetMenuItemOrDecendant = menuItemRefs.some(function (menuItem) {
      var isCheckboxOrRadio = isCheckboxItem(menuItem) || isRadioItem(menuItem);
      return menuItem.contains(e.target) && !isCheckboxOrRadio;
    }); // Close menu if the click is triggered from a MenuItem or
    // its decendant. Don't close the menu if the click is triggered
    // from a MenuItemRadio or MenuItemCheckbox so that the user can
    // select multiple items.

    if (isTargetMenuItemOrDecendant && onClose) {
      onClose();
    }
  };

  setInitialFocusRef && setInitialFocusRef(menuItemRefs[0]); // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props

  return /*#__PURE__*/React.createElement(MenuGroup, _extends({
    role: "menu",
    onClick: closeOnMenuItemClick
  }, props));
};

export default MenuWrapper;